import Alert from './alert';
import { toast } from 'react-toastify';

const alerts = [];
const defaultAlertConfig = {
    duration: 5000,
    hard: false
};

const removeItem = alertItem => {
    alerts.splice(alerts.indexOf(alertItem), 1);
}

export const createAlert = (type = 'alert', content, config = defaultAlertConfig) => {
    let alertItem;
    let originalOnHide = config.onHide;

    config.onHide = (...args) => {
        originalOnHide && originalOnHide(...args);

        if (!args[0]) {
            removeItem(alertItem);
        }
    }

    if (content instanceof Error) {
        if (content.response && content.response.data && content.response.data.message) {
            content = content.response.data.message;
        } else {
            content = 'Unknown error';
        }
    }

    alertItem = new Alert(type, content, config);

    alerts.push(alertItem);

    return alertItem;
}

export const createToast = (type = 'default', content: string, options?: OptionsType) => {
    toast(content, {
        ...(options || {}),
        type
    });
}

export const updateToast = (toastId, options) => {
    toast.update(toastId, options);
}

export const dismissToast = toastId => {
    toast.dismiss(toastId);
}
